(function () {
  var scope = document.querySelector('.c3-pdp');
  if (!scope) return;
  var variants = JSON.parse(scope.querySelector('[data-c3-variants]').textContent);
  var form = scope.querySelector('[data-c3-form]');
  var idInput = form.querySelector('[data-c3-id]');
  var buyBtn = form.querySelector('[data-c3-buy]');
  var addBtn = form.querySelector('[data-c3-add]');
  var err = form.querySelector('[data-c3-err]');
  var qEl = form.querySelector('[data-c3-q]');
  var figs = [].slice.call(scope.querySelectorAll('.c3-gal__item'));
  var dlg = document.getElementById('c3-sizeguide');
  var qty = 1;

  function selected() {
    return [].slice.call(form.querySelectorAll('.c3-opt')).map(function (fs) {
      var c = fs.querySelector('input:checked');
      return c ? c.value : null;
    });
  }
  function pick(sel) {
    var fs = form.querySelector(sel);
    var c = fs && fs.querySelector('input:checked');
    return c ? c.value : '';
  }
  function showGroup() {
    var c = pick('[data-c3-color]');
    var first = null;
    figs.forEach(function (f) {
      var g = f.getAttribute('data-color');
      var on = !c || !g || g === c;
      f.hidden = !on;
      f.classList.remove('is-first');
      if (on && !first) first = f;
    });
    if (first) first.classList.add('is-first');
    var title = scope.querySelector('[data-c3-colorname]');
    if (title && c) title.textContent = c;
  }
  function syncGuide() {
    if (!dlg) return;
    var c = pick('[data-c3-color]').toLowerCase();
    var s = pick('[data-c3-size]').toLowerCase();
    var any = false;
    [].slice.call(dlg.querySelectorAll('[data-c3-model]')).forEach(function (r) {
      var on = !c || r.getAttribute('data-color') === c;
      r.hidden = !on;
      if (on) any = true;
    });
    var box = dlg.querySelector('.c3-sg__models');
    if (box) { if (any) box.removeAttribute('data-empty'); else box.setAttribute('data-empty', ''); }
    [].slice.call(dlg.querySelectorAll('[data-col]')).forEach(function (cell) {
      cell.classList.toggle('is-sel', !!s && cell.getAttribute('data-col') === s);
    });
  }
  function update() {
    var sel = selected();
    [].slice.call(form.querySelectorAll('.c3-opt')).forEach(function (fs, i) { fs.querySelector('[data-c3-selected]').textContent = sel[i] || ''; });
    var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
    err.textContent = '';
    showGroup();
    syncGuide();
    if (!v) { buyBtn.disabled = addBtn.disabled = true; buyBtn.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    scope.querySelector('[data-c3-price-now]').textContent = v.price;
    var was = scope.querySelector('[data-c3-price-was]');
    if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.hidden = true; }
    buyBtn.disabled = addBtn.disabled = !v.available;
    buyBtn.textContent = v.available ? 'Buy now — ' + v.price : 'Sold out';
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
  }
  function fail(x) { err.textContent = x.message; update(); }
  function post() {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: qty }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; }); });
  }
  function buyNow() {
    buyBtn.disabled = addBtn.disabled = true;
    buyBtn.textContent = 'Redirecting…';
    post().then(function () { window.location.href = '/checkout'; }).catch(fail);
  }
  form.addEventListener('change', update);
  form.addEventListener('submit', function (e) { e.preventDefault(); buyNow(); });
  addBtn.addEventListener('click', function () {
    var txt = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    var done = function () { addBtn.textContent = txt; addBtn.disabled = false; };
    if (window.c3Cart) window.c3Cart.add(+idInput.value, qty).then(done).catch(function (x) { err.textContent = x.message; done(); });
    else post().then(function () { window.location.href = '/cart'; }).catch(fail);
  });
  form.querySelector('[data-c3-inc]').addEventListener('click', function () { qty = Math.min(qty + 1, 20); qEl.textContent = qty; });
  form.querySelector('[data-c3-dec]').addEventListener('click', function () { qty = Math.max(qty - 1, 1); qEl.textContent = qty; });

  var sg = scope.querySelector('[data-c3-sizeguide]');
  if (sg) sg.addEventListener('click', function (e) {
    e.preventDefault();
    syncGuide();
    if (dlg && dlg.showModal) dlg.showModal();
    else document.getElementById('c3-details').open = true;
  });
  if (dlg) dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-c3-sg-close]')) dlg.close();
  });
  showGroup();
  syncGuide();
})();